import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { noop } from 'lodash/noop';

import { SuiField } from '@splashthat/sui';
import ChevronDown from '../../icons/ChevronDown';

import FontFamilyPickerOption from './FontFamilyPickerOption';
import FontFamilyPickerPopover from './FontFamilyPickerPopover';

const BASE_CLASS_NAME = 'FontFamilyPicker';

export default class FontFamilyPicker extends Component {
    static propTypes = {
        fontFamilyList: PropTypes.arrayOf(PropTypes.object).isRequired,
        defaultFontFamily: PropTypes.object.isRequired,
        onChangeFontFamily: PropTypes.func.isRequired,
        getAnchorEl: PropTypes.func,
        getRefWidth: PropTypes.func,
        popoverClassName: PropTypes.string,
        qaId: PropTypes.string.isRequired,
        'aria-label': PropTypes.string,
    };

    static defaultProps = {
        getAnchorEl: noop,
        getRefWidth: noop,
        popoverClassName: null,
        'aria-label': undefined,
    };

    state = {
        popoverIsVisible: false,
    };

    handleOnChangeFontFamily = (e) => {
        const fontFamily = e.target.textContent;
        this.props.onChangeFontFamily(fontFamily);
    };

    showPopover = (e) => {
        e && e.stopPropagation();
        this.setState({
            popoverIsVisible: !this.state.popoverIsVisible,
        });
    };

    showFontFamilyPickerPopover = () => (
        <FontFamilyPickerPopover
            showPopover={this.state.popoverIsVisible}
            minWidth={this.props.getRefWidth()}
            anchorEl={this.props.getAnchorEl()}
            onClickClose={this.showPopover}
            fontFamilyList={this.props.fontFamilyList}
            onChangeFontFamily={this.props.onChangeFontFamily}
            defaultFontFamily={this.props.defaultFontFamily}
            className={this.props.popoverClassName}
            qaId={`${this.props.qaId}--popover`}
        />
    );

    render() {
        const { defaultFontFamily, qaId, 'aria-label': ariaLabel } = this.props;
        const { popoverIsVisible } = this.state;

        return (
            <React.Fragment>
                <SuiField
                    className={`${BASE_CLASS_NAME}__container`}
                    formElement={
                        <button
                            onClick={this.showPopover}
                            className={`${BASE_CLASS_NAME}__selector`}
                            data-qa={`${qaId}--dropdown`}
                            aria-label={ariaLabel}
                        >
                            <FontFamilyPickerOption font={defaultFontFamily.value} />
                            <ChevronDown />
                        </button>
                    }
                />
                {popoverIsVisible ? this.showFontFamilyPickerPopover() : null}
            </React.Fragment>
        );
    }
}
